import { userIsLoggedIn } from "~/domains/user/utils/roles";

export type OccCartUserPath = "/users/current" | "/users/anonymous";

export function occCartUserPathFor(authenticated: boolean): OccCartUserPath {
  return authenticated ? "/users/current" : "/users/anonymous";
}

/**
 * Returns the OCC user path segment for the current visitor.
 *
 * SAP Commerce requires `users/anonymous` for guest carts and `users/current` for
 * authenticated carts. Using `users/current` for an anonymous visitor causes the
 * OCC UserMatchingFilter to resolve the wrong owner (or 401), so every cart URL
 * must derive its user segment from this function.
 *
 * Kept in a standalone module so it can be imported alongside `occFetch` without
 * being affected by `occFetch` test mocks.
 */
export function occCartUserPath(): OccCartUserPath {
  return occCartUserPathFor(userIsLoggedIn());
}
